<template>
	<!-- Footer notifications -->
	<BaseAlertList />

	<div class="grid h-dvh grid-rows-[max-content_minmax(0,1fr)]">
		<HeaderNav sync />
		<StartNewLeadModal
			v-model:open="showConfirmationModal"
			@to-web-portal="handleGoToWebPortal"
			@to-sales-studio="handleGoToNewSession"
		/>
		<main
			class="grid grid-cols-[1fr_255px] grid-rows-[minmax(0,1fr)] gap-y-5 bg-gray-50 p-5 pr-0"
		>
			<div class="relative -mr-1 overflow-x-hidden overflow-y-scroll pr-1">
				<div
					v-if="submissionStore.failedSubmissions?.size"
					class="sticky top-0 z-10"
				>
					<SubmissionErrors />
				</div>
				<div>
					<UpcomingAppointments />
				</div>
			</div>
			<DeckRepeater
				class="mr-2"
				v-slot="{ deck, renderDeckThumbnail }"
			>
				<div
					class="inline-block cursor-pointer"
					@click.prevent="handleSelectDeck(deck)"
				>
					<component :is="renderDeckThumbnail" />
				</div>
			</DeckRepeater>
		</main>
	</div>
</template>

<script setup lang="ts">
import BaseAlertList from '@/components/common/BaseAlertList.vue'
import HeaderNav from '@/components/common/HeaderNav.vue'
import StartNewLeadModal from '@/components/common/StartNewLeadModal.vue'
import SubmissionErrors from '@/components/home/SubmissionErrors.vue'
import UpcomingAppointments from '@/components/home/UpcomingAppointments.vue'
import DeckRepeater from '@/components/home/decks/DeckRepeater.vue'
import { makeWebPortalUrl } from '@/services/webPortal'
import { useSubmissionStore } from '@/stores/submission'
import { useSyncStore } from '@/stores/sync'
import type { DeckPreview } from '@/types'
import { onMounted, onUnmounted, ref } from 'vue'
import { useRouter } from 'vue-router'

const sync = useSyncStore()
const submissionStore = useSubmissionStore()

const router = useRouter()

/** When the user arrives here, start up a sync if we're not already syncing */
onMounted(() => {
	sync.beginSync({ verify: false })

	// Periodically check for remote submission errors
	sync.startRemoteSubmissionErrorCheck()
})

onUnmounted(() => {
	sync.stopRemoteSubmissionErrorCheck()
})

const showConfirmationModal = ref(false)
const currentSelectedDeck = ref()

const handleSelectDeck = (deck: DeckPreview) => {
	currentSelectedDeck.value = deck
	showConfirmationModal.value = true
}

const handleGoToNewSession = () => {
	showConfirmationModal.value = false
	router.push({
		name: 'newSession',
		query: { deckId: currentSelectedDeck.value.uniqueId },
	})
}

const handleGoToWebPortal = () => {
	showConfirmationModal.value = false
	window.open(makeWebPortalUrl(`add-lead`))
}
</script>
